import * as ToggleGroup from '@radix-ui/react-toggle-group'

import { styled } from '~/styled'

export const standardVariant = [
  'before:bg-grey-600',
  'bg-white',
  'border',
  'border-grey-600',
  'text-grey-800',
  'data-[state=on]:border-current!',
  'data-[state=on]:inset-shadow-[currentColor_0px_0px_0px_1px]',
  'data-[state=on]:text-primary-800',
  'not-disabled:data-[state=on]:before:bg-none',
  'not-disabled:focus-visible:before:bg-none',
  'not-disabled:focus-visible:data-[state=off]:border-grey-600!',
  'not-disabled:focus-visible:data-[state=on]:shadow-[var(--color-primary-800)_0px_0px_0px_4px]',
  'not-disabled:focus-visible:data-[state=on]:inset-shadow-[currentColor_0px_0px_0px_1px]',
  'not-disabled:focus-visible:data-[state=on]:shadow-[white_0px_0px_0px_2px]',
  'not-disabled:focus-visible:outline-none',
  'not-disabled:focus-visible:relative',
  'not-disabled:focus-visible:shadow-[var(--color-primary-800)_0px_0px_0px_4px]',
  'not-disabled:focus-visible:shadow-[white_0px_0px_0px_2px]',
  'not-disabled:focus-visible:z-1',
  'not-disabled:hover:before:bg-none',
  'not-disabled:hover:border-current!',
  'not-disabled:hover:text-primary-900'
]

export const modernVariant = [
  'bg-grey-200',
  'border-0',
  'text-grey-800',
  'overflow-hidden',
  'rounded-md',
  'data-[state=on]:bg-white',
  'data-[state=on]:border!',
  'data-[state=on]:border-grey-200!',
  'data-[state=on]:shadow-none!',
  'data-[state=on]:text-grey-900',
  'not-disabled:focus-visible:data-[state=off]:border-grey-600!',
  'not-disabled:focus-visible:data-[state=on]:shadow-[var(--color-primary-800)_0px_0px_0px_4px]',
  'not-disabled:focus-visible:data-[state=on]:inset-shadow-[currentColor_0px_0px_0px_1px_white_0px_0px_0px_2px]',
  'not-disabled:focus-visible:outline-none',
  'not-disabled:focus-visible:relative',
  'not-disabled:focus-visible:shadow-[var(--color-primary-800)_0px_0px_0px_4px]',
  'not-disabled:focus-visible:shadow-[white_0px_0px_0px_2px]',
  'not-disabled:focus-visible:z-1',
  'not-disabled:hover:text-primary-900'
]

export const ToggleGroupItem = styled(ToggleGroup.Item, {
  base: [
    'cursor-pointer',
    'disabled:cursor-not-allowed',
    'disabled:opacity-30'
  ],
  variants: {
    theme: {
      standard: standardVariant,
      modern: modernVariant
    }
  },
  defaultVariants: {
    theme: 'standard'
  }
})
